// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__i1j-i","faIcon":"Navbar_faIcon__deDTm"};